import { Outlet, useLocation } from "react-router-dom";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import { useEffect, useState } from "react";
import Auth from "../../auth/Auth";
// import SoundBox from "../../../public";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
function Layout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const authData =  Auth.userInfo()?.udId,
  const { pathname } = useLocation();
  const [getLatLong, setGetLatLong] = useState({ updatelatitudeData: '', updatelongitudeData: '' });
  let restaurantList = useSelector((state) => state.restaurant.list);



  // useEffect(() => {
  //   if (!Auth.token()) {
  //     navigate("/")
  //   }
  // }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <>
      {
        restaurantList.loginActive === "false" ?
          <div className="centerBox"><div className="whiteBox-ctxt">
            <img src="assets/img/soundBox.svg" alt="centerBox img" />
            {restaurantList.errorMessage}</div></div> :
          <div>
            <Header getLatLong={getLatLong} setGetLatLong={setGetLatLong} />
            <Outlet context={{ getLatLong }} />

            <Footer />

          </div>
      }


    </>

  );
}

export default Layout;
